import GetLabel from "foundation/js/getLabel"
import { ref, onMounted } from 'vue'
import {useStore} from 'vuex'

export default {
    name: "FrivilligjobCard",
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const tags = ref([])
        const hasFetchedGruppeemner = ref(false)
        onMounted(() => {
            store
            .dispatch("frivilligjob/getGruppeemner", props.result.id)
            .then(result => {
                tags.value = result
                hasFetchedGruppeemner.value = true
            })
        })

        return {
            tags,
            hasFetchedGruppeemner,
            getLabel: (labelKey, params) => GetLabel({ labelKey, labelCollection: 'FrivilligjobCard', params })
        }
    }
}